import { useEffect } from 'react';

import Amplitude from 'services/Amplitude';
import LocalStorage from 'services/LocalStorage';
import { LocalStorageKey } from 'constants/local-storage';

export const useBeforeUnload = (shouldPreventUnload: boolean): void => {
  useEffect(() => {
    const handleOnBeforeUnload = (event: BeforeUnloadEvent): undefined | string => {
      if (!shouldPreventUnload) {
        return undefined;
      }

      Amplitude.logEvent(null, 'SIGNUP_ALERT_TRIGGERED');
      LocalStorage.set(LocalStorageKey.SignupAlertTriggered, true);

      event.preventDefault();
      // eslint-disable-next-line no-param-reassign
      event.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', handleOnBeforeUnload, { capture: true });

    return () => {
      window.removeEventListener('beforeunload', handleOnBeforeUnload, { capture: true });
    };
  }, [shouldPreventUnload]);
};
